<template>
  <div
    class="modal fade"
    id="sys_reviewAmmeter_modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title" id="myModalLabel">电表审核</h4>
        </div>
        <!-- modal-body-->
        <div class="modal-body form-horizontal">
          <div class="form-group">
            <label class="col-sm-3 control-label">所在基站名称</label>
            <div class="col-sm-3">
              <input
                name
                readonly
                class="form-control"
                v-model="infoAmmeter.stst_commname"
              />
            </div>
            <label class="col-sm-3 control-label">电表类型</label>
            <div class="col-sm-3">
              <input
                name
                readonly
                class="form-control"
                v-model="infoAmmeter.req_data.category"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 control-label">电表型号</label>
            <div class="col-sm-3">
              <input
                name
                readonly
                class="form-control"
                v-model="infoAmmeter.req_data.model"
              />
            </div>
            <label class="col-sm-3 control-label">电表编号</label>
            <div class="col-sm-3">
              <input
                name
                readonly
                class="form-control"
                v-model="infoAmmeter.req_data.numbering"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 control-label">经度</label>
            <div class="col-sm-3">
              <input
                name
                readonly
                class="form-control"
                v-model="infoAmmeter.req_data.longitude"
              />
            </div>
            <label class="col-sm-3 control-label">纬度</label>
            <div class="col-sm-3">
              <input
                name
                readonly
                class="form-control"
                v-model="infoAmmeter.req_data.latitude"
              />
            </div>
          </div>
          <div class="form-group">
            <div id="ammeter_map"></div>
          </div>
        </div>
        <!-- modal-footer -->
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            @click="conclusion('reject')"
          >
            拒绝
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="conclusion('pass')"
          >
            通过
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AMap from "AMap";

var map;
var marker;
export default {
  data() {
    return {
      infoAmmeterReq: {},
    };
  },
  props: ["infoAmmeter"],
  mounted: function () {},
  methods: {
    loadData: function () {
      var self = this;
      map = new AMap.Map("ammeter_map", {
        center: [
          self.infoAmmeter.req_data.longitude,
          self.infoAmmeter.req_data.latitude,
        ],
        resizeEnable: true,
        zoom: 16,
      });
      marker = new AMap.Marker({
        map: map,
        position: map.getCenter(),
        zIndex: 101,
        size: new AMap.Size(10, 10),
        offset: new AMap.Pixel(-20, -20),
      });
    },
    // 处理结果
    conclusion: function (type) {
      var self = this;
      self.global.axiosPut(
        self,
        "info_change/" + self.infoAmmeter.id + "/",
        { conclusion: type },
        function (res) {
          console.log("-----处理结果", res);
          if (res.status == "success") {
            alert("操作成功");
            $("#sys_reviewAmmeter_modal").modal("hide");
            $("#info_atptable").bootstrapTable("refresh");
          } else {
            alert(res.message);
          }
        },
        function () {
          alert("操作失败!");
        }
      );
    },
  },
};
</script>
<style scoped>
#ammeter_map {
  margin: 30px;
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/informationAudit/reviewAmmeter.vue